import request from "helper/request";

const warehouseApi = {
  // Warehouse endpoints
  getWarehouses: () => {
    return request.get("v1/inventory-management/warehouses");
  },

  getWarehousesByLocation: (savedLocationId) => {
    return request.get(
      `v1/inventory-management/warehouses/by-location/${savedLocationId}`
    );
  },

  getWarehouse: (warehouseId) => {
    return request.get(`v1/inventory-management/warehouses/${warehouseId}`);
  },

  createWarehouse: (data) => {
    return request.post("v1/inventory-management/warehouses", data);
  },

  updateWarehouse: (id, data) => {
    return request.put("v1/inventory-management/warehouses", { ...data, id });
  },

  deleteWarehouse: (id) => {
    return request.delete("v1/inventory-management/warehouses", { data: { id } });
  },

  // Inventory Item endpoints
  getInventoryItems: () => {
    return request.get("v1/inventory-management/inventory-items");
  },

  getWarehouseInventoryItems: (warehouseId) => {
    return request.get(
      `v1/inventory-management/warehouses/${warehouseId}/inventory-items`
    );
  },

  getInventoryItem: (itemId) => {
    return request.get(`v1/inventory-management/inventory-items/${itemId}`);
  },

  createInventoryItem: (data) => {
    return request.post("v1/inventory-management/inventory-items", data);
  },

  updateInventoryItem: (id, data) => {
    return request.put("v1/inventory-management/inventory-items", { ...data, id });
  },

  deleteInventoryItem: (id) => {
    return request.delete("v1/inventory-management/inventory-items", { data: { id } });
  },

  uploadInventoryItemImage: (itemId, formData) => {
    return request.post(
      `v1/inventory-management/inventory-items/${itemId}/image`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );
  },

  getSettings: () => {
    return request.get("v1/inventory-management/settings");
  },

  updateSettings: (data) => {
    return request.put("v1/inventory-management/settings", data);
  }
};

export default warehouseApi;
